/**
 * @generated SignedSource<<9a1c9b4eaa655f4e397866adb3603502>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsGrid_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItem_user">;
  readonly " $fragmentType": "PdpRespSimilarItemsGrid_user";
};
export type PdpRespSimilarItemsGrid_user$key = {
  readonly " $data"?: PdpRespSimilarItemsGrid_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsGrid_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f75bd8f8dbfd2cf0c25719e068ba0cbd";

export default node;
